import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useNavigate } from 'react-router-dom'
import { IntakeCard, CARD_CSS, type CardData } from '../components/IntakeCard'
import { PrintCardButton } from '../components/PrintCard'
import { cardFromRow, INTAKE_CARD_COLS, type IntakeRow } from '../lib/intakeCard'

// Reprint an older intake's card: shows the card, and Print card hands the exact 5x7 PDF to the share sheet.
export function PrintIntake() {
  const { id } = useParams()
  const nav = useNavigate()
  const [card, setCard] = useState<CardData | null>(null)
  const [err, setErr] = useState('')
  useEffect(() => {
    (async () => {
      const { data, error } = await supabase.from('intakes').select(INTAKE_CARD_COLS).eq('id', id!).maybeSingle()
      if (error || !data) { setErr('Intake not found'); return }
      setCard(cardFromRow(data as unknown as IntakeRow))
    })()
  }, [id])
  if (err) return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>{err}</div>
  if (!card) return null
  return (
    <div className="print-page">
      <style>{CARD_CSS}{`
        @page { size: 5in 7in; margin: 0; }
        html, body { background: #fff !important; margin: 0; }
        .print-page { width: 5in; height: 7in; position: relative; overflow: hidden; background: #fff; }
        .backbar { position: fixed; top: 12px; left: 12px; z-index: 5; }
        @media screen { body { background: #888 !important; } .print-page { margin: 24px auto; box-shadow: 0 4px 30px rgba(0,0,0,.4); } }
        @media print { .backbar { display: none; } }
      `}</style>
      <div className="backbar"><button type="button" className="seg__btn" onClick={() => nav('/intake/recent')}>‹ Back to the app</button><PrintCardButton card={card} className="seg__btn" /></div>
      <IntakeCard c={card} />
    </div>
  )
}
